// extracted by mini-css-extract-plugin
export default {"wrapper":"HomeWrapper_wrapper__kro78","homeSection":"HomeWrapper_homeSection__R8QE+","guideSection":"HomeWrapper_guideSection__h69nj"};